export class HistoryAction {
  static readonly type = '[History]';
  constructor(public payload: string) {}
}

export class ToggleDisplayColumn implements HistoryAction {
  static readonly type = '[History] Toggle Display Column';
  constructor(public payload: string) {}
}

export class GetEmailList {
  static readonly type = '[History] Get Email List';
  constructor(public skip?: number, public top?: number, public projectId?: number) {}
}

export class GetEmailAudit {
  static readonly type = '[History] Get Email Audit';
  constructor(public payload: string) {}
}
